import { EVENTS, PAGE_ERROR } from 'common/domain/constants';
import { STATES } from 'common/domain/states';
import { ENDPOINTS_LOANS } from 'common/endpoints/loans.endpoints';
import { LOANS, MIN_LENGTH_OF_SERVICE_FOR_SIGN_UP } from 'loans.module/common/domain/constants.loans';
import moment from 'moment';

export default class LoansOperationsService {
  constructor($log, $http, $state, $q, LoansUserDataService) {
    'ngInject';
    this.log = $log;
    this.http = $http;
    this.state = $state;
    this.q = $q;
    this.loansUserDataService = LoansUserDataService;
  }

  getCreditworthiness(employeeId) {
    return this.http
      .get(ENDPOINTS_LOANS.get.creditworthiness(employeeId))
      .then(response => {
        this.userHasntCreditworthiness = this.checkIfAllCreditWorthinessIsCero(
          response.data
        );
        this.loansUserDataService.setSenior(response.data.earlyRetired);
        if (this.userHasntCreditworthiness) {
          this.goToWageAdvance();
        }
        return this.assembleCreditworthiness(response.data);
      });
  }

  checkIfAllCreditWorthinessIsCero(data) {
    return data.allCero;
  }

  goToWageAdvance() {
    if (this.loansUserDataService.getSenior()) {
      this.state.go(STATES.ERROR, {
        stateName: PAGE_ERROR.LOANS_CLOSED_TO_USER_WITHOUT_CREDITWORTHINESS
      });
    } else {
      this.state.go(STATES.LOANS.WAGE_ADVANCE, {
        stateAccess: EVENTS.WITHOUT_LOANS_ACCESS
      });
    }
  }

  assembleCreditworthiness(creditworthiness) {
    let parsedCreditworthiness;

    try {
      parsedCreditworthiness = {
        hireDate: creditworthiness.hireDate,
        housingWitness: creditworthiness.housingWitness,
        maximumMonthFee: creditworthiness.maximumMonthFee,
        yourObligations: creditworthiness.yourObligations,
        yourRealCapacity: creditworthiness.yourRealCapacity,
        employeeProfile: creditworthiness.employeeProfile,
        simulationWitness: creditworthiness.simulationWitness,
        agreementHousingLoanFixedSimulated: creditworthiness.agreementHousingLoanFixedSimulated,
        agreementHousingLoanSimulated: creditworthiness.agreementHousingLoanSimulated,
        socialHousingLoanSimulated: creditworthiness.socialHousingLoanSimulated,
        socialHousingLoanFixedSimulated: creditworthiness.socialHousingLoanFixedSimulated
      };

      let showFiveMonth =
        creditworthiness.fiveMonth &&
        creditworthiness.fiveMonth[0].maximumLimit > 0;
      let showNineMonth =
        creditworthiness.nineMonth &&
        creditworthiness.nineMonth[0].maximumLimit > 0;
      let showVariousCredit =
        creditworthiness.variousCredit &&
        creditworthiness.variousCredit[0].maximumLimit > 0;
      let showSocialHousingLoan =
        creditworthiness.socialHousingLoan &&
        creditworthiness.socialHousingLoan[0].maximumLimit > 0;
      let showAgreementHousingLoan =
        creditworthiness.agreementHousingLoan &&
        creditworthiness.agreementHousingLoan[0].maximumLimit > 0;
      let showAgreementHousingLoanFixed =
        creditworthiness.agreementHousingLoanFixed &&
        creditworthiness.agreementHousingLoanFixed[0].maximumLimit > 0;
      let showSocialHousingLoanFixed =
        creditworthiness.socialHousingLoanFixed &&
        creditworthiness.socialHousingLoanFixed[0].maximumLimit > 0;
      let showdiversalAtention =
        creditworthiness.diversalAtention &&
        creditworthiness.diversalAtention[0].maximumLimit > 0;

      if (showFiveMonth) {
        parsedCreditworthiness.fiveMonth = creditworthiness.fiveMonth[0];
      }
      if (showNineMonth) {
        parsedCreditworthiness.nineMonth = creditworthiness.nineMonth[0];
      }
      if (showVariousCredit) {
        parsedCreditworthiness.variousCredit =
          creditworthiness.variousCredit[0];
      }
      if (showdiversalAtention) {
        parsedCreditworthiness.diversalAtention = 
        creditworthiness.diversalAtention[0];
      }
      if (showSocialHousingLoan) {
        parsedCreditworthiness.socialHousingLoan =
          creditworthiness.socialHousingLoan[0];
      }
      if (showAgreementHousingLoan) {
        parsedCreditworthiness.agreementHousingLoan =
          creditworthiness.agreementHousingLoan[0];
      }
      if (showAgreementHousingLoanFixed) {
        parsedCreditworthiness.agreementHousingLoanFixed =
          creditworthiness.agreementHousingLoanFixed[0];
      }
      if (showSocialHousingLoanFixed) {
        parsedCreditworthiness.socialHousingLoanFixed =
          creditworthiness.socialHousingLoanFixed[0];
      }
    } catch (error) {
      this.log.error(error);
      parsedCreditworthiness = {};
    }

    return parsedCreditworthiness;
  }

  createLoan(employeeId, loan) {
    const data = {
      loanSignup: [loan]
    };
    this.log.info('LoansOperationsService.create:', employeeId, data);
    return this.http.post(ENDPOINTS_LOANS.post.createLoan(employeeId), data);
  }

  cancelAmortization(employeeId, loan) {
    const identifying = loan.identifying;
    const data = {
      amortizations: [
        {
          identifying
        }
      ]
    };
    const config = {
      data
    };
    this.log.info(
      'LoansOperationsService.cancelAmortization:',
      employeeId,
      config
    );
    return this.http.delete(
      ENDPOINTS_LOANS.delete.amortization(employeeId),
      config
    );
  }

  canSignUp(loanId, creditworthinessOfLoan, hireDate) {
    if (loanId === LOANS.ID.SOCIAL_HOUSING_LOAN) {
      this.checkLengthOfService(hireDate);
    }

    this.checkCreditworthiness(creditworthinessOfLoan);
  }

  checkLengthOfService(hireDate) {
    if (!hireDate) {
      return this.log.info(
        'Hire date is not present, skip length of service check ...'
      );
    }

    const lengthOfService = this.getLengthOfService(hireDate);
    const lengthOfServiceError =
      lengthOfService < MIN_LENGTH_OF_SERVICE_FOR_SIGN_UP;

    if (lengthOfServiceError) {
      throw new Error('lengthOfServiceError');
    }
  }

  getLengthOfService(hireDateString) {
    const hireDate = new Date(hireDateString);
    const today = new Date();
    return moment(today).diff(hireDate, 'years');
  }

  checkCreditworthiness(creditworthinessOfLoan, simulationWitness) {
    if (simulationWitness) {
      return true;
    }
  
    const invalidInsuranceLimit = creditworthinessOfLoan.realWithInsuranceLimit === 0;
    const invalidNoInsuranceLimit = creditworthinessOfLoan.realWithoutInsuranceLimit === 0;
  
    return !(invalidInsuranceLimit && invalidNoInsuranceLimit);
  }

  getEuribor() {
    return this.http.get(ENDPOINTS_LOANS.get.dataEuribor());
  }

  getInterestSV(){
    return this.http.get(ENDPOINTS_LOANS.get.dataSV());
  }

  getInterestVC(){
    return this.http.get(ENDPOINTS_LOANS.get.dataVC());
  }

  putCadastralReference(employeeId, params) {
    return this.http
      .put(ENDPOINTS_LOANS.put.modifyCadastralReference(employeeId), params)
      .then(response => response.data);
  }

  getFamilies() {
    return this.http.get(ENDPOINTS_LOANS.get.familiesNeedALoan());
  }
}



// WEBPACK FOOTER //
// ./client/app/loans.module/common/services/loans.operations.service.js